import Model, { ID, IsoDateTime } from 'src/models/model'
import PaymentConnectorConfiguration from 'src/models/payment-connector/PaymentConnectorConfiguration'

export default class PaymentConnectorLog extends Model {
  static name = 'PaymentConnectorLog'

  static paginate = true

  static define () {
    this.fields = {
      id: {
        type: ID,
        required: true,
        output: true
      },
      command: {
        type: String,
        default: null,
        output: true
      },
      logData: {
        type: String,
        default: null,
        output: true
      },
      paymentConnectorConfiguration: {
        type: PaymentConnectorConfiguration,
        default: null,
        output: true
      },
      createdAt: {
        type: IsoDateTime,
        default: null,
        output: true
      },
      updatedAt: {
        type: IsoDateTime,
        default: null,
        output: true
      }
    }
  }
}
